import {useState, useEffect} from "react";
import "./style.css";
import axios from "axios";

const PinLift = () => {
const [pin, setPin] = useState({});
  const getPin = async() => {
   const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/lift_truck_pins`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
    if (res.data.code=== 1) {
      setPin(res.data.data)
    }
  }

  useEffect(()=> {getPin()}, [])
  return (
    <div className="pin-container">
      <h1 className="pin-title">Pin de montacarga</h1>

      <div className="pin-box">
        <h3 className="pin-label">Pin del día</h3>
        <h1 className="pin-value">{pin?.pin}</h1>
        <p className="pin-date">Última actualización: {pin?.dates}</p>
      </div>
    </div>
  );
};

export default PinLift;
